import React from 'react';

export const formatContent = (obj) => {
  // 1. Si lo que recibe no es un objeto, devolvemos un fragmento vacío para evitar errores
  if (!obj || typeof obj !== 'object') return <></>;

  const listPattern = /[a-z]-\.\s?/;

  // 2. Iteramos sobre las claves del objeto (p1, p2, p3...)
  return Object.keys(obj).map((key) => {
    const text = obj[key].texto;

    // Si el texto de este párrafo tiene el formato de lista
    if (listPattern.test(text)) {
      const parts = text.split(/(?=[a-z]-\.)/);
      const header = parts.shift();

      return (
        <div key={key} className="block-list">
          <p><strong>{header}</strong></p>
          <ul>
            {parts.map((item, index) => (
              <li key={index}>
                {/* <span className="marker">{item.match(/[a-z]-\./)}</span> */}
                {item.replace(listPattern, '')}
              </li>
            ))}
          </ul>
        </div>
      );
    }

    // Si es un párrafo normal
    return <p key={key}>{text}</p>;
  });
};